import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Chip,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import { Refresh, Circle } from '@mui/icons-material';
import { useInFlightMessages } from '../../hooks/useInFlightMessages';
import InFlightMessageCard from '../molecules/InFlightMessageCard';
import { ConnectionStatus } from '../../interface/returnOps';

const connectionLabel: Record<ConnectionStatus, { text: string; color: string }> = {
    connecting: { text: 'Connecting...', color: '#ff9800' },
    connected: { text: 'Live', color: '#4caf50' },
    polling: { text: 'Polling', color: '#2196f3' },
    disconnected: { text: 'Disconnected', color: '#9e9e9e' },
};

const InFlightPanel = () => {
    const { messages, connectionStatus, reconnect } = useInFlightMessages();

    const { text: connText, color: connColor } = connectionLabel[connectionStatus];

    const startedCount = messages.filter((m) => m.status === 'started').length;
    const processingCount = messages.filter((m) => m.status === 'processing').length;
    const completedCount = messages.filter((m) => m.status === 'completed').length;
    const failedCount = messages.filter((m) => m.status === 'failed').length;

    return (
        <Card>
            <CardHeader
                title="In-Flight Messages"
                action={(
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip
                            icon={<Circle sx={{ fontSize: 10 }} />}
                            label={connText}
                            size="small"
                            sx={{
                                '& .MuiChip-icon': { color: connColor },
                                fontWeight: 500,
                            }}
                        />
                        <IconButton onClick={reconnect}>
                            <Refresh />
                        </IconButton>
                    </Box>
                )}
            />
            <CardContent>
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                    {startedCount > 0 && <Chip label={`${startedCount} started`} color="info" size="small" />}
                    {processingCount > 0 && <Chip label={`${processingCount} processing`} color="warning" size="small" />}
                    {completedCount > 0 && <Chip label={`${completedCount} completed`} color="success" size="small" />}
                    {failedCount > 0 && <Chip label={`${failedCount} failed`} color="error" size="small" />}
                </Stack>

                {messages.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                            No in-flight messages
                        </Typography>
                    </Box>
                ) : (
                    <Stack spacing={1.5} sx={{ maxHeight: 600, overflow: 'auto' }}>
                        {messages.map((msg) => (
                            <InFlightMessageCard key={msg.messageId} message={msg} />
                        ))}
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
};

export default InFlightPanel;
